/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xray_LabelInputs */

const en_xray_label = /** @type {(inputs: Xray_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X-ray`)
};

const fr_xray_label = /** @type {(inputs: Xray_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rayons X`)
};

const ms_sg2_xray_label = /** @type {(inputs: Xray_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinar-X`)
};

/**
* | output |
* | --- |
* | "X-ray" |
*
* @param {Xray_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const xray_label = /** @type {((inputs?: Xray_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xray_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xray_label(inputs)
	if (locale === "fr") return fr_xray_label(inputs)
	return ms_sg2_xray_label(inputs)
});